/** Routes mirror the EDC module tree in MNG_ModuleLists (Controller names). */
export const EDC_PATHS = {
  root: "/EDC",
  management: "/EDC/Management",
  areas: "/EDC/Management/Areas",
  substations: "/EDC/Management/SubstationInformation",
  feeders: "/EDC/Management/FeederInformation",
  lvTrans: "/EDC/Management/LVTrans",
  users: "/EDC/Management/Users",
  supervisors: "/EDC/Supervisors",
  engineering: "/EDC/Engineering",
};

export const REQUEST_VIEWS = [
  { key: "NewRequests", title: "درخواست های جدید" },
  { key: "InProcessing", title: "در حال بررسی" },
  { key: "AcceptedRequests", title: "تایید شده" },
  { key: "RejectedRequests", title: "رد شده" },
];

export const REQUEST_UNITS = {
  area: {
    key: "area",
    title: "ناظران توزیع",
    basePath: EDC_PATHS.supervisors,
    tabs: {
      NewRequests: "area",
      InProcessing: "area-inprocess",
      AcceptedRequests: "area-accepted",
      RejectedRequests: "area-rejected",
    },
  },
  engineering: {
    key: "engineering",
    title: "واحد مهندسی",
    basePath: EDC_PATHS.engineering,
    tabs: {
      NewRequests: "engineering",
      InProcessing: "engineering-inprocess",
      AcceptedRequests: "engineering-accepted",
      RejectedRequests: "engineering-rejected",
    },
  },
};

export const requestViewPath = (unitKey, viewKey = "NewRequests") =>
  `${REQUEST_UNITS[unitKey].basePath}/${viewKey}`;
